import { useDispatch, useSelector } from 'react-redux';
import { DropDownButton, DropdownItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TimeUnit } from '@mews/enums';
import { createHandler } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { changeTimeUnit } from '../../actions';
import { getSelectedTimeUnit } from '../../selectors/view';

const getTextKey = createHandler({
    [TimeUnit.Hour]: TextKey.TimelineBreakdownHours,
    [TimeUnit.Day]: TextKey.Days,
    [TimeUnit.Month]: TextKey.Months,
});

export const TimeUnitSelect: React.FC<{ disabled: boolean }> = ({ disabled }) => {
    const dispatch = useDispatch();
    const value = useSelector(getSelectedTimeUnit);

    const handleClick = (timeUnit: TimeUnit) => {
        dispatch(changeTimeUnit(timeUnit));
    };

    return (
        <DropDownButton
            data-test-id="timeline-time-unit-select"
            label={<LocalizedText textKey={getTextKey(value)} />}
            disabled={disabled}
            size="medium"
        >
            {Object.values(TimeUnit).map((timeUnit) => (
                <DropdownItem
                    key={timeUnit}
                    onClick={() => handleClick(timeUnit)}
                    label={<LocalizedText textKey={getTextKey(timeUnit)} />}
                    selected={value === timeUnit}
                    disabled={disabled}
                />
            ))}
        </DropDownButton>
    );
};
